// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cardsContainer[data-v-515c8393] {\n  display: grid;\n  grid-gap: 25px 15px;\n  grid-template-columns: repeat(auto-fill, minmax(181px, 1fr));\n}", ""]);
// Exports
module.exports = exports;
